"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const valueIsString_1 = __importDefault(require("../typeAssertions/valueIsString"));
const getInternationalizationValue = ({ internationalizationValues, locale, value, }) => {
    var _a;
    if (!value) {
        return undefined;
    }
    if ((0, valueIsString_1.default)(value)) {
        return value;
    }
    if (value.type === 'raw') {
        return value.default;
    }
    if (!internationalizationValues) {
        return value.default;
    }
    const { key } = value;
    if (!locale) {
        return value.default;
    }
    const localeValues = (_a = internationalizationValues.byLocale) === null || _a === void 0 ? void 0 : _a[locale];
    if (!localeValues) {
        return value.default;
    }
    const localeValue = localeValues[key];
    if (!localeValue) {
        return value.default;
    }
    return localeValue;
};
exports.default = getInternationalizationValue;
